import type { FC, ReactNode } from 'react';

const Layout : FC<{ children: ReactNode }>= ({ children }) => (<>{children}</>)

export default Layout
